// File: src/components/social/LikeButton/LikeButton.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { Heart } from "lucide-react";

interface LikeButtonProps {
  liked?: boolean;
  onToggle: () => void;
}

const Button = styled.button<{ liked: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.sm};
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ liked, theme }) => (liked ? theme.colors.error : theme.colors.textSecondary)};
  font-weight: ${({ theme }) => theme.fonts.fontWeightMedium};
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    color: ${({ liked, theme }) => (liked ? theme.colors.error : theme.colors.textPrimary)};
  }
`;

export const LikeButton: React.FC<LikeButtonProps> = ({ liked = false, onToggle }) => {
  return (
    <Button liked={liked} onClick={onToggle} aria-label="Like button">
      <Heart size={20} fill={liked ? "currentColor" : "none"} />
      {liked ? "Liked" : "Like"}
    </Button>
  );
};